/*
 *  I08CALCVOLEXPI18n.js
 *
 *  Created by Sébastien Hecart on 2017-12-11 12:07:43 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

export default {
  I08CALCVOLEXP_SECTION_0_TITLE: "Calculez le vase d'expansion d'une installation de chauffage",
  I08CALCVOLEXP_I12VOLINSTCHAUF: 'Calculer le volume ou saissisez manuellement',
  I08CALCVOLEXP_in_volEauRet: "Volume d'eau installation",
  I08CALCVOLEXP_in_temperature: 'Température moyenne du réseau',
  I08CALCVOLEXP_SECTION_1_TITLE: '',
  I08CALCVOLEXP_in_hauteurInstallation: "Hauteur de l'installation à partir du vase",
  I08CALCVOLEXP_in_hauteurVase: 'Hauteur entre vase et soupape',
  I08CALCVOLEXP_in_pressionMin: 'NPSH Pompe',
  I08CALCVOLEXP_res_pressionGonflage: 'Pression statique/gonflage',
  I08CALCVOLEXP_in_pressionSoupape: 'Pression soupape',
  I08CALCVOLEXP_in_pressionRefoulement: 'Pression refoulement pompe',
  I08CALCVOLEXP_res_pressionMax: 'Pression max',
  I08CALCVOLEXP_res_pressionFinal: 'Pression final',
  I08CALCVOLEXP_SECTION_2_TITLE: '',
  I08CALCVOLEXP_res_facteurPression: 'Facteur pression',
  I08CALCVOLEXP_res_volumeVaseExpansion: 'Volume de vase expansion',
  I08CALCVOLEXP_SECTION_3_TITLE: '',
  I08CALCVOLEXP_in_volumVaseChoisit: 'Volume du vase choisi',
  I08CALCVOLEXP_res_volumeReserve2: 'Volume de réserve',
  I08CALCVOLEXP_res_vPressionInitial: 'Pression initiale du vase',
  I08CALCVOLEXP_res_pressionInitialVase: 'Pression initiale du vase',
  I08CALCVOLEXP_res_facteurPression_inadapte: 'Pression inadaptée',
  I08CALCVOLEXP_res_volumeReserve2_non_conforme: 'Vase non conforme'
}
